/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShellRouteImport } from './routes/_shell'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ShellLeadsRouteImport } from './routes/_shell/leads'
import { Route as ShellOverzichtRouteImport } from './routes/_shell/overzicht'
import { Route as ShellPakkettenRouteImport } from './routes/_shell/pakketten'
import { Route as ShellAbonnementenIndexRouteImport } from './routes/_shell/abonnementen/index'
import { Route as ShellAbonnementenIdRouteImport } from './routes/_shell/abonnementen/$id'
import { Route as ShellAbonnementenNewRouteImport } from './routes/_shell/abonnementen/new'
import { Route as ShellKlantenIndexRouteImport } from './routes/_shell/klanten/index'
import { Route as ShellKlantenIdRouteImport } from './routes/_shell/klanten/$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellRoute = ShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellLeadsRoute = ShellLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => ShellRoute,
} as any)
const ShellOverzichtRoute = ShellOverzichtRouteImport.update({
  id: '/overzicht',
  path: '/overzicht',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPakkettenRoute = ShellPakkettenRouteImport.update({
  id: '/pakketten',
  path: '/pakketten',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAbonnementenIndexRoute = ShellAbonnementenIndexRouteImport.update({
  id: '/abonnementen/',
  path: '/abonnementen/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAbonnementenIdRoute = ShellAbonnementenIdRouteImport.update({
  id: '/abonnementen/$id',
  path: '/abonnementen/$id',
  getParentRoute: () => ShellRoute,
} as any)
const ShellAbonnementenNewRoute = ShellAbonnementenNewRouteImport.update({
  id: '/abonnementen/new',
  path: '/abonnementen/new',
  getParentRoute: () => ShellRoute,
} as any)
const ShellKlantenIndexRoute = ShellKlantenIndexRouteImport.update({
  id: '/klanten/',
  path: '/klanten/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellKlantenIdRoute = ShellKlantenIdRouteImport.update({
  id: '/klanten/$id',
  path: '/klanten/$id',
  getParentRoute: () => ShellRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/leads': typeof ShellLeadsRoute
  '/overzicht': typeof ShellOverzichtRoute
  '/pakketten': typeof ShellPakkettenRoute
  '/abonnementen/$id': typeof ShellAbonnementenIdRoute
  '/abonnementen/new': typeof ShellAbonnementenNewRoute
  '/klanten/$id': typeof ShellKlantenIdRoute
  '/abonnementen/': typeof ShellAbonnementenIndexRoute
  '/klanten/': typeof ShellKlantenIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/leads': typeof ShellLeadsRoute
  '/overzicht': typeof ShellOverzichtRoute
  '/pakketten': typeof ShellPakkettenRoute
  '/abonnementen/$id': typeof ShellAbonnementenIdRoute
  '/abonnementen/new': typeof ShellAbonnementenNewRoute
  '/klanten/$id': typeof ShellKlantenIdRoute
  '/abonnementen': typeof ShellAbonnementenIndexRoute
  '/klanten': typeof ShellKlantenIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_shell': typeof ShellRouteWithChildren
  '/login': typeof LoginRoute
  '/_shell/leads': typeof ShellLeadsRoute
  '/_shell/overzicht': typeof ShellOverzichtRoute
  '/_shell/pakketten': typeof ShellPakkettenRoute
  '/_shell/abonnementen/$id': typeof ShellAbonnementenIdRoute
  '/_shell/abonnementen/new': typeof ShellAbonnementenNewRoute
  '/_shell/klanten/$id': typeof ShellKlantenIdRoute
  '/_shell/abonnementen/': typeof ShellAbonnementenIndexRoute
  '/_shell/klanten/': typeof ShellKlantenIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/leads'
    | '/overzicht'
    | '/pakketten'
    | '/abonnementen/$id'
    | '/abonnementen/new'
    | '/klanten/$id'
    | '/abonnementen/'
    | '/klanten/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/leads'
    | '/overzicht'
    | '/pakketten'
    | '/abonnementen/$id'
    | '/abonnementen/new'
    | '/klanten/$id'
    | '/abonnementen'
    | '/klanten'
  id:
    | '__root__'
    | '/'
    | '/_shell'
    | '/login'
    | '/_shell/leads'
    | '/_shell/overzicht'
    | '/_shell/pakketten'
    | '/_shell/abonnementen/$id'
    | '/_shell/abonnementen/new'
    | '/_shell/klanten/$id'
    | '/_shell/abonnementen/'
    | '/_shell/klanten/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ShellRoute: typeof ShellRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell': {
      id: '/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ShellRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell/leads': {
      id: '/_shell/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof ShellLeadsRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/overzicht': {
      id: '/_shell/overzicht'
      path: '/overzicht'
      fullPath: '/overzicht'
      preLoaderRoute: typeof ShellOverzichtRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/pakketten': {
      id: '/_shell/pakketten'
      path: '/pakketten'
      fullPath: '/pakketten'
      preLoaderRoute: typeof ShellPakkettenRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/abonnementen/': {
      id: '/_shell/abonnementen/'
      path: '/abonnementen'
      fullPath: '/abonnementen/'
      preLoaderRoute: typeof ShellAbonnementenIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/abonnementen/$id': {
      id: '/_shell/abonnementen/$id'
      path: '/abonnementen/$id'
      fullPath: '/abonnementen/$id'
      preLoaderRoute: typeof ShellAbonnementenIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/abonnementen/new': {
      id: '/_shell/abonnementen/new'
      path: '/abonnementen/new'
      fullPath: '/abonnementen/new'
      preLoaderRoute: typeof ShellAbonnementenNewRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/klanten/': {
      id: '/_shell/klanten/'
      path: '/klanten'
      fullPath: '/klanten/'
      preLoaderRoute: typeof ShellKlantenIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/klanten/$id': {
      id: '/_shell/klanten/$id'
      path: '/klanten/$id'
      fullPath: '/klanten/$id'
      preLoaderRoute: typeof ShellKlantenIdRouteImport
      parentRoute: typeof ShellRoute
    }
  }
}

interface ShellRouteChildren {
  ShellLeadsRoute: typeof ShellLeadsRoute
  ShellOverzichtRoute: typeof ShellOverzichtRoute
  ShellPakkettenRoute: typeof ShellPakkettenRoute
  ShellAbonnementenIdRoute: typeof ShellAbonnementenIdRoute
  ShellAbonnementenNewRoute: typeof ShellAbonnementenNewRoute
  ShellKlantenIdRoute: typeof ShellKlantenIdRoute
  ShellAbonnementenIndexRoute: typeof ShellAbonnementenIndexRoute
  ShellKlantenIndexRoute: typeof ShellKlantenIndexRoute
}

const ShellRouteChildren: ShellRouteChildren = {
  ShellLeadsRoute: ShellLeadsRoute,
  ShellOverzichtRoute: ShellOverzichtRoute,
  ShellPakkettenRoute: ShellPakkettenRoute,
  ShellAbonnementenIdRoute: ShellAbonnementenIdRoute,
  ShellAbonnementenNewRoute: ShellAbonnementenNewRoute,
  ShellKlantenIdRoute: ShellKlantenIdRoute,
  ShellAbonnementenIndexRoute: ShellAbonnementenIndexRoute,
  ShellKlantenIndexRoute: ShellKlantenIndexRoute,
}

const ShellRouteWithChildren = ShellRoute._addFileChildren(ShellRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ShellRoute: ShellRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
